import { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb';

export const Breadcrumb: BreadcrumbDesignTokens = {
  root: {
    background: 'none',
    padding: '0'
  },
  item: {
    color: '{surface.700}'
  },
  colorScheme: {
    light: {

    }
  }
}
